export const emailsJoiner = '; ';

export const emailsSeparators = [' ', ',', ';'];
